<template>
  <v-dialog persistent v-model="value" max-width="290">
    <v-form @submit.prevent="save">
      <v-card>
          <v-card-title class="headline">{{documentType ? $t('Pages.DocumentTypes.update') : $t('Pages.DocumentTypes.add_new')}}</v-card-title>

          <v-card-text>
            <v-layout column wrap>
              <v-flex xs12 md5>
                <v-text-field
                  v-validate="'required'"
                  v-model="newDocumentType.name"
                  :error-messages="errors.first('name')"
                  :label="$t('Pages.DocumentTypes.model.name')"
                  type="text"
                  name="name"
                />
              </v-flex>
              <v-flex xs12 md5>
                <v-text-field
                  v-model="newDocumentType.description"
                  :label="$t('Pages.DocumentTypes.model.description')"
                  type="text"
                  name="description"
                />
              </v-flex>
              <v-flex xs12 md5>
                <v-text-field
                  v-model="newDocumentType.duration"
                  :label="$t('Pages.DocumentTypes.model.duration')"
                  type="number"
                  name="duration"
                >
                  <v-tooltip top slot="append-outer">
                    <v-icon slot="activator">mdi-help-circle</v-icon>
                    <span>{{ $t('Pages.DocumentTypes.note') }}</span>
                  </v-tooltip>
                </v-text-field>
              </v-flex>
            </v-layout>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn @click="close">
                {{$t('Core.Fields.close')}}
            </v-btn>

            <v-btn dark color="success dark1" type="submit">
                {{$t('Core.Fields.save')}}
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import _ from 'lodash';
  export default {
    props: ['value', 'documentType'],
    data: () => ({
      newDocumentType: {}
    }),
    methods: {
      close(){
        this.newDocumentType = {};
        this.$emit('close')
        this.$validator.reset()
      },
      save(){
        this.$validator.validateAll().then((result) => {
          if (result) {
            if(!this.documentType) {
              this.repositories.documentType.store(this.newDocumentType)
                .then(response => {
                  this.$toast.success(response.data.message);
                  this.newDocumentType = {};
                  this.$emit('refresh', response.data.data);
                  this.close();
                });
            } else {
              this.repositories.documentType.update(this.newDocumentType.id, this.newDocumentType)
                .then(response => {
                  this.$toast.success(response.data.message);
                  this.newDocumentType = {};
                  this.$emit('refresh');
                  this.close();
                });
            }
          }
        });
      }
    },
    watch: {
      'value': function() {
        if(this.value && this.documentType) {
          this.newDocumentType = { ...this.documentType }
        }
      }
    }
  }
</script>

<style lang="scss">

</style>